<template>
  <div>
    <div class="container">
      <div class="row">
        <v-file-input
          v-model="fileupload"
          color="light-purple accent-4"
          label="File input"
          @change="selectFile"
          placeholder="Select your file"
          prepend-icon="mdi-file-upload-outline"
          outlined
          accept=".csv"
        >
        </v-file-input>
      </div>
      <div class="row pl-8">
         <h4 class="text-center red--text">
              {{ errorMessage }}
         </h4>
         <span class="pl-3" v-if="errorMessage">
                Sample File: 
                <a style="text-decoration: none" href="/importusers.csv" download v-if="action_for == 'user_imports'">
                  Sample CSV file for User Import
                </a>
                <a style="text-decoration: none" href="/importoffices.csv" download v-if="action_for == 'office_imports'">
                  Sample CSV file for Office Import
                </a>
              </span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex"
export default {
  data: () => ({
    fileupload: null,
    errorMessage: null,
  }),
  methods: {
    async selectFile(file) {
      let that = this;
      if (file) {
        let config = {
          header: true,
          dynamicTyping: true,
          skipEmptyLines: true,
          complete: function(results) {
            that.$store.dispatch("file_imports/process_csv", {data:results.data, action_for: this.action_for});
            that.csvContent = results.data;
          },
        };
        await this.$papa.parse(file, config);
      }
    },
  },
  computed:{
    ...mapState({
      action_for: (state) => state.file_imports.action_for,
      data: (state) => state.file_imports.data
    })
  },
  watch: {
    data: function(){
      if(this.action_for ==  'user_imports')
        try{
          let exist = null;
          this.data.forEach(row => {
            exist = Object.keys(row).some(key => key === 'email')
            if(!exist)
              throw 'Break'
            exist = Object.keys(row).some(key => key === 'first_name')
            if(!exist)
              throw 'Break'
            exist = Object.keys(row).some(key => key === 'middle_name')
            if(!exist)
              throw 'Break'
            exist = Object.keys(row).some(key => key === 'last_name')
            if(!exist)
              throw 'Break'
          })
          throw 'No Error found'
        }catch(e) {
          if(e == 'Break'){
            this.errorMessage = "Imported CSV file is not in correct format"
            this.$emit('emptyData', false, true)
          }
          else{
            this.$store.dispatch('file_imports/set_user_data_with_roles',this.data)
            this.errorMessage = null
            this.$emit('emptyData', true, false)
          }
        }
        
      if(this.action_for ==  'office_imports')
        try{
            let exist = null;
            this.data.forEach(row => {
              exist = Object.keys(row).some(key => key === 'name')
              if(!exist)
                throw 'Break'
              exist = Object.keys(row).some(key => key === 'type')
              if(!exist)
                throw 'Break'
              exist = Object.keys(row).some(key => key === 'location')
              if(!exist)
                throw 'Break'
              exist = Object.keys(row).some(key => key === 'status')
              if(!exist)
                throw 'Break'
            })
            throw 'No Error found'
          }catch(e) {
            if(e == 'Break'){
              this.errorMessage = "Imported CSV file is not in correct format"
              this.$emit('emptyData', false, true)
            }
            else{
              this.$store.dispatch('file_imports/set_office_data',this.data)
              this.errorMessage = null
              this.$emit('emptyData', true, false)
            }
          }
    }
  },
  mounted: function(){
    this.fileupload = null
  }
};
</script>
